import { useSearchParams } from 'react-router-dom'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { PageHeader } from '@/components/layout/page-header'
import { AcceptInvitation } from '@/app/(dashboard)/settings/users/accept/_components/AcceptInvitation'

export function AcceptInvitationPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')?.trim()

  return (
    <div className="flex h-full flex-col">
      <PageHeader
        title="Accept Invitation"
        description="Confirm Helm account access"
        breadcrumbs={[
          { label: 'Settings', href: '/settings' },
          { label: 'Users', href: '/settings/users' },
          { label: 'Accept Invitation' },
        ]}
      />

      <div className="max-w-xl p-4 md:p-6">
        {token ? (
          <AcceptInvitation token={token} />
        ) : (
          <Alert variant="destructive">
            <AlertDescription>Invitation token is missing.</AlertDescription>
          </Alert>
        )}
      </div>
    </div>
  )
}
